// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3Vm8U","buttons":"SendReceipts_buttons__3Je9i","email":"SendReceipts_email__3yrqB","bookApptTitle":"SendReceipts_bookApptTitle__1iFL8"};